import { Factory } from 'miragejs';

import { assert } from '@qonto/mirage/utils/assert';

export default Factory.extend({
  counterpartyName: 'Welcome to the jungle',
  amount: {
    value: '9.99',
    currency: 'EUR',
  },
  localAmount: {
    value: '10.73',
    currency: 'USD',
  },
  emittedAt: '2023-12-17T07:38:54.000Z',
  activityTag: 'online_service',
  side: 'debit',
  bookkeepingStatus: 'to_verify',
  operationMethod: null,
  vat: null,
  note: null,
  attachmentLost: false,
  attachmentRequired: false,
  attachmentRequested: false,
  enrichmentData: () => {},
  attachmentSuggestionIds: () => [],

  afterCreate(transaction) {
    assert(
      transaction.subject,
      `Missing 'subject' relationship on 'transaction:${transaction.id}'`
    );

    // For now we only infer the initiator from the following subjects, since these are the only subjects that have an initiator
    if (['card', 'check', 'transfer'].includes(transaction.subject.modelName)) {
      assert(
        !transaction.initiator && !transaction.initiatorId,
        `You should not pass an 'initiator' relationship on 'transaction:${transaction.id}'. This needs to be set on the subject.`
      );
    }

    if ('initiator' in transaction.subject) {
      transaction.update({ initiator: transaction.subject.initiator });
    }

    if ('holder' in transaction.subject) {
      transaction.update({ initiator: transaction.subject.holder });
    }

    if (!transaction.operationMethod) {
      let operationMethod;
      let subjectType = transaction.subject.modelName;
      if (
        subjectType === 'transfer' ||
        subjectType === 'income' ||
        subjectType === 'swift-income'
      ) {
        operationMethod = 'transfer';
      } else if (subjectType === 'card') {
        operationMethod = 'card';
      } else if (subjectType === 'check') {
        operationMethod = 'cheque';
      } else if (subjectType === 'direct-debit' || subjectType === 'direct-debit-collection') {
        operationMethod = 'direct_debit';
      } else if (subjectType === 'wallet-to-wallet') {
        operationMethod = 'biller';
      } else if (subjectType === 'pagopa-payment') {
        operationMethod = 'pagopa_payment';
      } else if (subjectType === 'f24-payment') {
        operationMethod = 'tax';
      } else if (subjectType === 'financing-income' || subjectType === 'financing-installment') {
        operationMethod = 'pay_later';
      } else {
        assert(false, `Unknown subject type on \`transaction:${transaction.id}\``);
      }

      transaction.update({ operationMethod });
    }

    if (!transaction.hasOwnProperty('activityTag')) {
      let activityTag;
      let subjectType = transaction.subject.modelName;
      if (subjectType === 'pagopa-payment') {
        activityTag = 'other_expense';
      } else if (subjectType === 'f24-payment') {
        activityTag = 'tax';
      } else {
        activityTag = 'finance';
      }

      transaction.update({ activityTag });
    }

    if (!transaction.side) {
      let subjectType = transaction.subject.modelName;
      let isCreditSubject = [
        'income',
        'swift-income',
        'check',
        'financing-income',
        'direct-debit-collection',
      ].includes(subjectType);
      let side = isCreditSubject ? 'credit' : 'debit';

      transaction.update({ side });
    }
  },
});
